export default __webpack_public_path__ + "static/media/tree_2.79f667ee.png";